/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityTorrentsResult } from './MonitEntityTorrentsResult';
import {
    MonitEntityTorrentsResultFromJSON,
    MonitEntityTorrentsResultFromJSONTyped,
    MonitEntityTorrentsResultToJSON,
} from './MonitEntityTorrentsResult';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityTorrentsResponse
 */
export interface MonitPaginatedEntityTorrentsResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityTorrentsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityTorrentsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityTorrentsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityTorrentsResult>}
     * @memberof MonitPaginatedEntityTorrentsResponse
     */
    results?: Array<MonitEntityTorrentsResult>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityTorrentsResponse interface.
 */
export function instanceOfMonitPaginatedEntityTorrentsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityTorrentsResponseFromJSON(json: any): MonitPaginatedEntityTorrentsResponse {
    return MonitPaginatedEntityTorrentsResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityTorrentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityTorrentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityTorrentsResultFromJSON)),
    };
}

export function MonitPaginatedEntityTorrentsResponseToJSON(value?: MonitPaginatedEntityTorrentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityTorrentsResultToJSON)),
    };
}

